import { Address, Err, IEvent, IPlace, IUser, Result } from '@/classes'
import { SearchBoxSuggestion, SearchBoxAdministrativeUnitTypes } from '@mapbox/search-js-core'
import { IOrganization } from '~/classes/Organization'

export const placesGetAPI = async (filters: {
	_ids?: string[]
	geolocation?: [number, number]
	distance?: number
}, options: FetchOptions, controller?: AbortController) => {
	const response: Result<{
		places: IPlace[]
	}> = await fetchAPI('places2/get', { filters, options }, { method: 'POST', controller })
	
	return response
}

export const placesGetOneAPI = async (
	_id: string
) => {
	const response: Result<{
		place: IPlace | null
		users: IUser[]
		organizations: IOrganization[]
		events: IEvent[]
	}> = await fetchAPI('places2/one', { _id }, { method: 'POST'})
	
	return response
}

export const placeCreateAPI = async (
	params: { _id: string, isRequested?: boolean}
) => {
	const response: Result<{
		created: IPlace | null
	}> = await fetchAPI('places/create', { params }, { method: 'POST' })

	return response
}

export const placeReviewAPI = async (
	placeId: string,
	review: {
		rating: number
		comment: string
		recommend: '' | 'yes' | 'no' | 'maybe'
		events: '' | 'yes' | 'no' | 'maybe'
		feeling: '' | 'yes' | 'no'
		symbols: '' | 'yes' | 'no'
		isAnonymous: boolean
	}
) => {
	const response: Result<{ place: IPlace | null }> = await fetchAPI('places2/review', { placeId, review }, { method: 'POST' })
	
	return response
}

export const placeAutocompleteAPI = async (
	input: string,
  options?: {
		sessionToken?: string
		types?: SearchBoxAdministrativeUnitTypes[]
	}
 ) => {
	const response: Result<{
		suggestions: SearchBoxSuggestion[]
		sessionToken: string
	}> = await fetchAPI('places2/autocomplete', { input, options }, { method: 'POST' })

	return response
}

export const placeAutocompleteGetAPI = async (
	suggestion: SearchBoxSuggestion,
  options?: {
		sessionToken?: string
		isAddress?: boolean
	}
 ) => {
	const response: Result<{
		place: IPlace | null
		address: Address
		sessionToken: string
	}> = await fetchAPI('places2/autocomplete/get', { suggestion, options }, { method: 'POST' })

	return response
}

export const placeEditAPI = async (
	placeId: string,
	params: any
 ) => {
	const response: Result<{
		place: IPlace | null
	}> = await fetchAPI('places2/edit', { placeId, params }, { method: 'POST' })
	if (!response.ok) return response
	
	return response
}
